import React from 'react';
import { useOrderTypeContext } from '../../../Contexts/OrderTypeContext';
import { formatCurrency } from '../../../Utils/Formatters';
import { useTranslation } from 'react-i18next';

interface BoxContentMinimumOrderValueProps {
  cart: any;
  show: boolean;
  loading: boolean;
}

const BoxContentMinimumOrderValue = ({ cart, show=true, loading=false }: BoxContentMinimumOrderValueProps) => {

    const { t } = useTranslation();
    const { isDelivery } = useOrderTypeContext();

    const total = Number(cart.total_with_discount) || 0;
    const minimum = Number(cart.minimum_order_value) || 0;

    if (!show || !isDelivery || minimum <= 0) return null;

    const remainingValue = Math.max(minimum - total, 0);
    const percentageObtained = Math.min((total / minimum) * 100, 100);

    const message = percentageObtained >= 100
        ? t('cart.minimum_order_value.title')
        : remainingValue < 2 
            ? t('cart.minimum_order_value.value_not_reached', {remainingValue: formatCurrency(remainingValue)}) 
            : t('cart.minimum_order_value.value_not_reached_plural', {remainingValue: formatCurrency(remainingValue)});

    return (
        <div className="grid gap-1 w-full my-2 text-sm text-shopfood-title font-semibold text-center">

            <span>{message}</span>

            <div className={`w-full bg-gray-100 rounded-full shadow-inner h-1.5 overflow-hidden transition-all duration-250 ease-in-out ${loading ? 'animate-pulse' : ''}`}>
                <div
                    className="bg-custom-primary h-full rounded-full transition-all duration-700 ease-in-out"
                    style={{ width: `${percentageObtained}%` }}
                ></div>
            </div>
        </div>
    );
};

export default BoxContentMinimumOrderValue;
